<template>
  <a href="#breadcrumbsId"
    class="skip_box"
    tabindex="0" role="button"
    @click="toContent()"
    @keypress.enter.prevent="toContent()"
  >
    Skip Navigation >>
  </a>
</template>

<script>
export default {
  methods: {
    toContent() {
      setTimeout(() => {
        // window.scrollTo(1,0);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }, '100');
    },
 },
};
</script>

<style lang="sass" scoped>
  .skip_box
    display: block;
    white-space: nowrap;
    top: 0;
    background: none repeat scroll 0 0 #fff;
    box-shadow: 2px 1px 3px #666;
    font-size: 0.85rem;
    padding: 3px 5px;
    margin-left: 60px;
    position: absolute;
    left: 0;
    opacity: 0;
    z-index: 11;
  .skip_box:focus
    opacity: 1;
</style>